import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'AmountFormatter',
  standalone: false,
})
export class AmountFormatterPipe implements PipeTransform {
  transform(value: any): string {
    const formatter = new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formatter.format(value);
  }
}
